import { TTab } from '../../../utils';
import style from './Tab.module.scss';
import avatarIcon from "../../../assets/pictures/icons/avatar-icon.svg";
import sceneIcon from "../../../assets/pictures/icons/video-icon.svg";
import viewIcon from "../../../assets/pictures/icons/view-icon-grey.svg";
import { useTranslation } from 'react-i18next';

type Props = {
  name: TTab;
  active: boolean;
  setActiveTab: (tab: TTab) => void;
};

const iconsMap: Record<TTab, JSX.Element> = {
  appearance: <img className={`${style.icon} ${style.iconFirst}`} src={avatarIcon} alt="avatar icon" />,
  scene: <div className={style.icon}><img src={sceneIcon} alt="camera icon" /></div>,
  preview: <div className={style.icon}><img src={viewIcon} alt="eye icon" /></div>,
};

export const Tab = ({ name, active, setActiveTab }: Props) => {
  const { t } = useTranslation('tabs');
  const handleClick = () => {
    setActiveTab(name);
  };
  
  return (
      <div className={`${style.tabContainer} ${active && style.active}`} onClick={handleClick}>
        {iconsMap[name]}
        <span>{t(name)}</span>
      </div>
  );
};
